module.exports = "pegasus_template/assets/themecapture1/large/1.png";